export default "__VITE_ASSET__X0xKCY6v__"